








import Vue from "vue";

import { DayOfWeekEnum, getSingleDayOfWeekLabel } from "@/model/data/reportSubscription/DayOfWeekEnum";

export default Vue.extend({
    props: {
        value: Number,
    },
    computed: {
        toggleDays: {
            get: function () {
                let res: number[] = [];
                for (let i = 0; i < 7; i++) {
                    if (this.value & (1 << i)) {
                        res.push(i);
                    }
                }
                return res;
            },
            set: function (newValue: number[]) {
                let ret = 0;
                newValue.forEach((c) => {
                    ret |= 1 << c;
                });
                this.$emit("input", ret);
            },
        },
        daysOfWeekStrings(): number[] {
            let res: number[] = [];
            for (let item in DayOfWeekEnum) {
                if (!isNaN(Number(item))) {
                    res.push(Number(item));
                }
            }
            return res;
        },
    },
    methods: {
        getSingleDayOfWeekLabel,
    },
});
